/* global tns */
import "./_gallery-styles.scss";

/**
 * Gallery block — frontend slider initialization.
 * Depends on tiny-slider (tns) loaded from CDN via wp_enqueue_script.
 * Both scripts are output in footer; tiny-slider is enqueued first.
 */
const gallerySliders = document.querySelectorAll( '.b-gallery__slider' );

if ( gallerySliders.length && typeof tns !== 'undefined' ) {

	gallerySliders.forEach( ( slider ) => {

		const svgPrev = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg><span class="screen-reader-text">Poprzedni</span>';
		const svgNext = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg><span class="screen-reader-text">Następny</span>';

		tns( {
			container: slider,
			items: 1,
			slideBy: 1,
			gutter: 5,
			loop: true,
			mouseDrag: true,
			autoplay: true,
			autoplayTimeout: 5000,
			autoplayButtonOutput: false,
			controls: true,
			controlsText: [ svgPrev, svgNext ],
			edgePadding: 30,
			nav: false,
			speed: 400,
			responsive: {
				600: {
					items: 2,
				},
				1024: {
					items: 4,
				},
			},
		} );

	} );

}
